export class AlertSummary {
  battery_low_alert_sum: Number;
  high_flow_alert_sum: Number;
  low_flow_alert_sum: Number;
  magnetic_alert_sum: Number;
  total_alerts_sum: Number;

  constructor() {
    this.battery_low_alert_sum = 0;
    this.high_flow_alert_sum = 0;
    this.low_flow_alert_sum = 0;
    this.magnetic_alert_sum = 0;
    this.total_alerts_sum = 0;
  }
}
